import React from 'react';
import { SellingZoneGraphItem } from '@substratahq/selling-zone/typing/base';
import { DetailedAnalysisEmail } from '../../../../../../../store/deals/deals.types';
import { nextMoveGreyIcon, nextMoveIcon } from './assets';

type Props = {
  currentEmail: DetailedAnalysisEmail | null;
  emailsInBranch?: number;
  nextMoveMessage?: string;
  isThreadComplete?: boolean;
  selectedGraphItem?: SellingZoneGraphItem | null;
  goToLastMessage: () => void;
};

export const NextMove: React.FC<Props> = ({
  currentEmail,
  emailsInBranch,
  nextMoveMessage,
  isThreadComplete,
  goToLastMessage,
}): JSX.Element => {
  const isLastMessageInBranch =
    emailsInBranch && currentEmail?.index === emailsInBranch - 1;

  const attrs = {
    wrapper: {
      className: 'next-move',
      style:
        isThreadComplete || !nextMoveMessage?.length
          ? { border: '1px solid #D8D8D8' }
          : {},
    },
    header: {
      wrapper: { className: 'next-move__header' },
      img: {
        className: 'next-move__header-img',
        src:
          isThreadComplete || !nextMoveMessage?.length
            ? nextMoveGreyIcon
            : nextMoveIcon,
      },
    },
    body: {
      wrapper: { className: 'next-move__body' },
      message: {
        className: 'next-move__body-message',
        style:
          !isLastMessageInBranch && nextMoveMessage?.length
            ? { marginTop: '16px' }
            : {},
      },
      goToLastEmail: {
        wrapper: { className: 'next-move__body__last-email' },
        link: {
          className: 'next-move__body__last-email-link',
          onClick: goToLastMessage,
        },
      },
    },
    footer: {
      wrapper: { className: 'next-move__footer' },
    },
  };

  const defineNextMoveMessage = () => {
    let message = 'No suggestions at the moment.';

    if (!isLastMessageInBranch && nextMoveMessage?.length) {
      message =
        'To view the suggestions go to the most recent message in the thread.';
    } else if (
      isLastMessageInBranch &&
      nextMoveMessage?.length &&
      !isThreadComplete
    ) {
      message = nextMoveMessage;
    } else if (isThreadComplete) {
      message = 'This thread is marked complete.';
    }
    return message;
  };

  const conditionalMessage = defineNextMoveMessage();

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.header.wrapper}>
        Next Move <img {...attrs.header.img} alt="" />
      </div>
      <div {...attrs.body.wrapper}>
        <div {...attrs.body.message}>{conditionalMessage}</div>
        {!isLastMessageInBranch && nextMoveMessage?.length ? (
          <div {...attrs.body.goToLastEmail.wrapper}>
            <div {...attrs.body.goToLastEmail.link}>
              Go to most recent message {'>'}
            </div>
          </div>
        ) : null}
      </div>
      <div {...attrs.footer.wrapper} />
    </div>
  );
};
